import React from 'react'
import './home.css'
import video from '../../Assets/video1.mp4'


const Home = () => {
  return (
   <section className="section home" id="home">
      <div className="overlay"></div>
      <video src={video} muted autoPlay loop type="video/mp4"></video>

      <div className="home__content container">

        <article className="home__text">
          <h1 className="home__title">Find your Destination with Bandoeng</h1>
          <span className="home__teks">Explore & Relax with the beauty of Kota Kembang & Paris Van Java</span>
          <br />
          <button className="home__btn">Get Started</button>
        </article>

      
      </div>
   </section>
  )
}

export default Home